module.exports = require("./sw.js");